/**
 * Alpine x-data factory for public/member poll response forms.
 * Must be on window before Alpine.start() (public layout has no @stack('scripts')).
 */
export function surveyResponseForm(rules, sortOrderToId, initialAnswers = {}) {
    return {
        answers: { ...initialAnswers },
        rules,
        sortOrderToId,
        setAnswer(questionId, value) {
            this.answers[questionId] = value;
        },
        toggleCheckbox(questionId, value, checked) {
            const current = Array.isArray(this.answers[questionId]) ? [...this.answers[questionId]] : [];
            if (checked && !current.includes(value)) {
                current.push(value);
            }
            if (!checked) {
                const idx = current.indexOf(value);
                if (idx >= 0) {
                    current.splice(idx, 1);
                }
            }
            this.answers[questionId] = current;
        },
        isQuestionVisible(questionId) {
            const rule = this.rules[questionId];
            if (!rule || !rule.enabled) {
                return true;
            }
            const parentId = this.sortOrderToId[rule.depends_on_index];
            if (!parentId) {
                return true;
            }
            const actual = this.answers[parentId];
            const expected = rule.value;
            switch (rule.operator) {
                case 'not_empty':
                    return actual !== null && actual !== '' && !(Array.isArray(actual) && actual.length === 0);
                case 'empty':
                    return actual === null || actual === '' || (Array.isArray(actual) && actual.length === 0);
                case 'equals':
                    return Array.isArray(actual)
                        ? actual.map(String).includes(String(expected))
                        : String(actual) === String(expected);
                case 'not_equals':
                    return Array.isArray(actual)
                        ? !actual.map(String).includes(String(expected))
                        : String(actual) !== String(expected);
                case 'contains':
                    return String(actual ?? '').toLowerCase().includes(String(expected ?? '').toLowerCase());
                case 'greater_than':
                    return Number(actual) > Number(expected);
                case 'less_than':
                    return Number(actual) < Number(expected);
                default:
                    return true;
            }
        },
        prepareSubmit() {
            this.$el.querySelectorAll('[data-survey-question]').forEach((block) => {
                const qid = Number(block.dataset.surveyQuestion);
                if (!this.isQuestionVisible(qid)) {
                    block.querySelectorAll('input, select, textarea').forEach((el) => {
                        el.removeAttribute('required');
                        el.disabled = true;
                    });
                }
            });
        },
    };
}
